export default __webpack_public_path__ + "static/media/pexels-andrea.48fd8817.png";